module.exports = __webpack_public_path__ + "img/experts.a4b4d4c7.png";